import { ReactNode } from "react";

export function convertYoutubeUrl(url: string) {
  let id;
  if (url.includes("youtu.be/")) {
    id = url.split("youtu.be/")[1];
  } else if (url.includes("youtube.com/watch?v=")) {
    id = url.split("v=")[1];
    const ampersandPosition = id.indexOf("&");
    if (ampersandPosition !== -1) {
      id = id.substring(0, ampersandPosition);
    }
  }

  if (id) {
    return "https://www.youtube.com/embed/" + id;
  } else {
    return url;
  }
}

export function createMarkup(children: ReactNode) {
  if (typeof children === "undefined" || children === null) {
    return { __html: "" };
  }

  const htmlString = Array.isArray(children)
    ? children.join(" ")
    : children.toString();

  const stringWithReplacements = htmlString
    .replace(/&nbsp;/g, "\u00A0")
    .replace(/&#8288;/g, "\u2060");

  return { __html: stringWithReplacements };
}
